import { useGetNotifications, useBillingPortal } from "@gettactic/hooks";
import { NotificationBanner } from "./NotificationBanner";
import type { Notification, NotificationType } from "@gettactic/api";
import { toast } from "react-hot-toast";

export const NotificationsList: React.FC = () => {
  const { data, isLoading } = useGetNotifications();
  const { openBillingPortal } = useBillingPortal();

  const fallbackActions: Partial<Record<NotificationType, () => Promise<void>>> = {
    billing_unpaid: async () => {
      const success = await openBillingPortal();
      if (!success) {
        toast.error("Failed to navigate to the billing portal");
      }
    },
  };

  const handleNotificationClick = async (notification: Notification) => {
    if (!notification.cta && fallbackActions[notification.type]) {
      await fallbackActions[notification.type]?.();
    }
  };

  if (isLoading || !data?.result?.notifications?.length) {
    return null;
  }

  return (
    <>
      {data.result.notifications.map((notification) => (
        <NotificationBanner
          key={notification.id}
          notification={notification}
          onClick={handleNotificationClick}
        />
      ))}
    </>
  );
};
